export default "__VITE_ASSET__Bz$cM8$k__"